module.exports = __webpack_public_path__ + "static/crm-partnership-4e409014480871581bb7ef76987b451e.png";